import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { useLanguage } from '../hooks/useLanguage';
import { useScrollReveal } from '../hooks/useScrollReveal';
import { CheckCircleIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
export function MerchantAcquiringPage() {
  const {
    t,
    setLocale,
    direction,
    locale
  } = useLanguage();
  const location = useLocation();
  const {
    ref: heroRef,
    isVisible: heroVisible
  } = useScrollReveal();
  const {
    ref: descRef,
    isVisible: descVisible
  } = useScrollReveal();
  const {
    ref: desc2Ref,
    isVisible: desc2Visible
  } = useScrollReveal();
  const {
    ref: featuresRef,
    isVisible: featuresVisible
  } = useScrollReveal();
  const {
    ref: moreServicesRef,
    isVisible: moreServicesVisible
  } = useScrollReveal();
  const {
    ref: ctaRef,
    isVisible: ctaVisible
  } = useScrollReveal();
  useEffect(() => {
    if (location.pathname.startsWith('/ar')) {
      setLocale('ar');
    } else {
      setLocale('en');
    }
    window.scrollTo(0, 0);
  }, [location.pathname, setLocale]);
  const column1Features = [t('merchantAcquiringPage.features.posEcommerce'), t('merchantAcquiringPage.features.statisticsDashboard'), t('merchantAcquiringPage.features.fraudMonitoring'), t('merchantAcquiringPage.features.disputesManagement'), t('merchantAcquiringPage.features.mpos')];
  const column2Features = [t('merchantAcquiringPage.features.accountManagement'), t('merchantAcquiringPage.features.merchantInternet'), t('merchantAcquiringPage.features.dcc'), t('merchantAcquiringPage.features.flexibleReporting'), t('merchantAcquiringPage.features.customerSupport')];
  return <div className="min-h-screen w-full bg-white text-slate-900" dir={direction} data-id="element-732">
      <Header variant="transparent-dark" data-id="element-733" />

      <main data-id="element-734">
        {/* Wrapper for hero SVG spanning hero + next sections */}
        <div className="relative" data-id="element-735">
          {/* Decorative SVG - spans hero and next 2 sections */}
          <img src="https://cdn.magicpatterns.com/uploads/nkA8NY64niUffzUbiE5oLU/about-hero.svg" alt="" role="presentation" aria-hidden="true" className="absolute right-0 pointer-events-none z-[1]" style={{
          top: '50vh',
          height: '60%'
        }} data-id="element-736" />

          {/* 1. Hero Banner */}
          <section className="relative min-h-screen overflow-hidden" ref={heroRef} aria-label="Merchant Acquiring Hero" data-id="element-737">
            {/* Background Image */}
            <div className="absolute inset-0 bg-cover bg-center" role="presentation" aria-hidden="true" style={{
            backgroundImage: "url('https://cdn.magicpatterns.com/uploads/5yMj6pfff5bvG4qVzy8djm/merchant-aquiring.jpg')"
          }} data-id="element-738" />

            <div className="relative z-10 w-full min-h-screen flex items-center" data-id="element-739">
              <div className="container mx-auto px-6 md:px-12" data-id="element-740">
                <div className="max-w-3xl" data-id="element-741">
                  <h1 className={`text-[#061D76] font-semibold leading-[1.05] mb-10 uppercase text-[32px] md:text-[44px] lg:text-[55px] whitespace-pre-line reveal-hidden ${heroVisible ? 'animate-fade-up' : ''}`} data-id="element-742">
                    {t('merchantAcquiringPage.hero.title')}
                  </h1>
                  <p className={`text-base md:text-lg text-[#061D76] mb-10 max-w-xl leading-relaxed reveal-hidden ${heroVisible ? 'animate-fade-up delay-200' : ''}`} data-id="element-743">
                    {t('merchantAcquiringPage.hero.subtitle')}
                  </p>
                </div>
              </div>
            </div>
          </section>

          {/* 2. Description Section - Dark gradient with text only */}
          <section className="section-inner gradient-dark-horizontal text-white relative overflow-hidden z-[2]" ref={descRef} aria-label="Merchant Acquiring Overview" data-id="element-744">
            <div className="container mx-auto px-6 md:px-12 relative z-10" data-id="element-745">
              <div className="max-w-5xl" data-id="element-746">
                <p className={`text-lg md:text-xl leading-relaxed reveal-hidden ${descVisible ? 'animate-fade-up' : ''}`} data-id="element-747">
                  {t('merchantAcquiringPage.description.paragraph1')}
                </p>
              </div>
            </div>
          </section>

          {/* 3. Light Section */}
          <section className="section-inner gradient-light relative overflow-hidden" ref={desc2Ref} aria-label="Merchant Acquiring Benefits" data-id="element-748">
            <div className="container mx-auto px-6 md:px-12 relative z-10" data-id="element-749">
              <div className="max-w-5xl" data-id="element-750">
                <p className={`text-lg md:text-xl text-[#061d76] leading-relaxed reveal-hidden ${desc2Visible ? 'animate-fade-up' : ''}`} data-id="element-751">
                  {t('merchantAcquiringPage.description.paragraph2')}
                </p>
              </div>
            </div>
          </section>
        </div>

        {/* 4. Features Checklist Section - WHITE background, 2 columns */}
        <section className="py-32 md:py-44 bg-white relative overflow-hidden" ref={featuresRef} aria-label="Merchant Acquiring Features" data-id="element-752">
          {/* Top-left decorative SVG */}
          <img src="https://cdn.magicpatterns.com/uploads/sjKgqbQqigcz9DMA9Uxgwc/top-left-csc-offers.svg" alt="" role="presentation" aria-hidden="true" className="absolute top-0 left-0 w-[300px] md:w-[500px] h-auto pointer-events-none opacity-10" data-id="element-753" />

          <div className="container mx-auto px-6 md:px-12 relative z-10" data-id="element-754">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-24 gap-y-6" data-id="element-755">
              {/* Column 1 */}
              <ul className="space-y-4" data-id="element-756">
                {column1Features.map((feature, index) => <li key={index} className={`flex items-center gap-3 reveal-hidden ${featuresVisible ? 'animate-fade-up' : ''}`} style={{
                animationDelay: `${index * 50}ms`
              }} data-id="element-757">
                    <CheckCircleIcon className="w-5 h-5 flex-shrink-0 text-[#25B8D6]" aria-hidden="true" data-id="element-758" />
                    <span className="text-[#061D76]" data-id="element-759">{feature}</span>
                  </li>)}
              </ul>

              {/* Column 2 */}
              <ul className="space-y-4" data-id="element-760">
                {column2Features.map((feature, index) => <li key={index} className={`flex items-center gap-3 reveal-hidden ${featuresVisible ? 'animate-fade-up' : ''}`} style={{
                animationDelay: `${(index + 5) * 50}ms`
              }} data-id="element-761">
                    <CheckCircleIcon className="w-5 h-5 flex-shrink-0 text-[#25B8D6]" aria-hidden="true" data-id="element-762" />
                    <span className="text-[#061D76]" data-id="element-763">{feature}</span>
                  </li>)}
              </ul>
            </div>
          </div>
        </section>

        {/* 5. More Services Section */}
        <section className="py-32 md:py-44 text-white relative overflow-hidden gradient-dark" dir={direction} ref={moreServicesRef} aria-label="More Services" data-id="element-764">
          {/* Background Curves */}
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_right,_var(--tw-gradient-stops))] from-[#1d8bba]/30 via-transparent to-transparent" aria-hidden="true" data-id="element-765"></div>

          {/* Top-right SVG decoration */}
          <img src="https://cdn.magicpatterns.com/uploads/2mANLj8GZ2QSoaHCJvcbje/more-service-top.svg" alt="" role="presentation" aria-hidden="true" className="absolute top-0 right-0 w-[300px] md:w-[300px] h-auto pointer-events-none opacity-10" data-id="element-766" />

          {/* Bottom-left SVG decoration */}
          <img src="https://cdn.magicpatterns.com/uploads/6b9oFepPZ3EmycFXG1ZrBP/4.svg" alt="" role="presentation" aria-hidden="true" className="absolute bottom-0 left-0 w-[1000px] h-auto pointer-events-none" data-id="element-767" />

          <div className="container mx-auto px-6 md:px-12 relative z-10" data-id="element-768">
            <h2 className={`text-white font-bold mb-12 reveal-hidden ${moreServicesVisible ? 'animate-fade-up' : ''}`} style={{
            fontSize: '1.6rem'
          }} data-id="element-769">
              {t('merchantAcquiringPage.moreServices')}
            </h2>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-0" data-id="element-770">
              {[{
              title: t('services.cardIssuing.title'),
              description: t('services.cardIssuing.description'),
              icon: 'https://cdn.magicpatterns.com/uploads/p9wNgXqTf5s865qgqSB29i/card.svg',
              href: locale === 'ar' ? '/ar/services/card-issuing' : '/services/card-issuing'
            }, {
              title: t('services.atmAcquiring.title'),
              description: t('services.atmAcquiring.description'),
              icon: 'https://cdn.magicpatterns.com/uploads/jegNccbhUz8TByzbmLGE3q/atm.svg',
              href: locale === 'ar' ? '/ar/services/atm-acquiring' : '/services/atm-acquiring'
            }, {
              title: t('services.mobilePayments.title'),
              description: t('services.mobilePayments.description'),
              icon: 'https://cdn.magicpatterns.com/uploads/jXad5oEVGh1pDvZH3TPpsH/mobile.svg',
              href: locale === 'ar' ? '/ar/services/mobile-payments' : '/services/mobile-payments'
            }].map((service, index) => <Link key={index} to={service.href} className={`group py-10 px-6 md:px-8 border border-white/10 hover:bg-[#25B8D6] transition-colors duration-300 cursor-pointer flex flex-col items-center justify-center text-center aspect-square reveal-hidden ${moreServicesVisible ? 'animate-fade-up' : ''}`} style={{
              animationDelay: `${(index + 1) * 100}ms`
            }} data-id="element-771">
                  <img src={service.icon} alt={service.title} className="w-10 h-10 mb-6 opacity-80 group-hover:opacity-100 transition-opacity" data-id="element-772" />
                  <h3 className="text-lg md:text-xl font-bold mb-3" data-id="element-773">
                    {service.title}
                  </h3>
                  <p className="text-white leading-relaxed text-sm" data-id="element-774">
                    {service.description}
                  </p>
                </Link>)}
            </div>
          </div>
        </section>

        {/* 6. Join Our Bold Thinkers CTA */}
        <section className="relative py-24 text-white overflow-hidden" dir={direction} ref={ctaRef} aria-label="Call to Action" data-id="element-775">
          {/* Background Image */}
          <div className="absolute inset-0 bg-cover bg-center" role="presentation" aria-hidden="true" style={{
          backgroundImage: "url('https://cdn.magicpatterns.com/uploads/aNushftuwBdDBhG34PgQWF/Trusted.jpg')"
        }} data-id="element-776"></div>

          <div className="container mx-auto px-6 md:px-12 relative z-10" data-id="element-777">
            <div data-id="element-778">
              <h2 className={`text-4xl md:text-5xl font-bold mb-6 whitespace-pre-line reveal-hidden ${ctaVisible ? 'animate-fade-left' : ''}`} data-id="element-779">
                {t('aboutPage.cta.heading')}
              </h2>
              <p className={`text-white max-w-[950px] text-lg mb-8 leading-relaxed reveal-hidden ${ctaVisible ? 'animate-fade-left delay-200' : ''}`} data-id="element-780">
                {t('aboutPage.cta.description')}
              </p>
              <button className={`btn-primary reveal-hidden ${ctaVisible ? 'animate-fade-up delay-400' : ''}`} data-id="element-781">
                {t('aboutPage.cta.button')}
              </button>
            </div>
          </div>
        </section>
      </main>

      <Footer data-id="element-782" />
    </div>;
}